import { useQuery } from '@tanstack/react-query'

import api, {
  type RecommendedListingsParams,
  type RecommendedListingsResponse,
} from '@api/search'

export const useRecommendedListingsQuery = (
  params?: RecommendedListingsParams
) => {
  return useQuery<RecommendedListingsResponse>({
    queryKey: ['recommendedListings', params],
    queryFn: () => api.fetchRecommendedListings(params),
  })
}
